import * as React from "react";
import { BaseEdgeDataType } from "../WorkflowUtils";
import { BasePortChildPropsType } from "./BasePort";

/**
 * Each <BasePort> component contains on <BasePortChild> component provided through the "PortChildComponent" property.
 *
 * The BasePortChild is a <foreignObject> which displays additional content, such as:
 * - A warning when an entry port is not reachable.
 * - A warning when an output port is not connected.
 */
const BasePortChild: React.FunctionComponent<BasePortChildPropsType> = (
  props
) => {
  const { isNodeReachable, port, isDragging, x, y, allNodes, allEdges } = props;

  const links: BaseEdgeDataType[] | undefined = allEdges?.filter(
    (edge: BaseEdgeDataType) =>
      port?.side === "WEST"
        ? edge?.toPort === port?.id
        : edge?.fromPort === port?.id
  );
  const shouldDisplayUnreachableWarning =
    port?.side === "WEST" && !isNodeReachable;
  const shouldDisplayUnlinkedWarning =
    port?.side === "EAST" && !links?.length && !isDragging;
  const hasContentToDisplay =
    shouldDisplayUnreachableWarning || shouldDisplayUnlinkedWarning;

  let warning: string;

  if (shouldDisplayUnreachableWarning) {
    warning = `This node is not reachable because there are no edge connected to its entry port.`;
  } else if (shouldDisplayUnlinkedWarning) {
    warning = `This port is not linked to any other node.`;
  }

  // Don't render content if there are no content to display
  if (!hasContentToDisplay) {
    return null;
  }

  // Move the content a bit to the left for the West port, and to the right for the right port
  const newX = x + (port?.side === "WEST" ? -40 : 20);
  const newY = y - 10;

  return (
    <foreignObject
      // Content width/height will be limited by the width of the foreignObject
      width={30}
      height={30}
      x={newX}
      y={newY}
    >
      {/* <div className={"port-content"}>XXX</div> */}
    </foreignObject>
  );
};

export default BasePortChild;
